import { getSessionId } from '../utils/userSessionId';

interface IResolveAPIHeaders {
	appName: string;
	appVersion?: string;
	appNameSuffix?: string;
	isDev?: boolean;
}

export const GRAPHQL_INTROSPECTION_KEY_HEADER = 'X-GraphQL-Introspection-Key';
export const CLIENT_APPLICATION_HEADER = 'X-Client-Application';
export const CLIENT_APPLICATION_VERSION_HEADER = 'X-Client-Application-Version';
export const CLIENT_SESSION_ID_HEADER = 'X-Session-Id';

/**
 * Should be used as appName in development environment - when we are calling graph from whatever client app (localhost), postman, banana cake pop, playground, etc.
 */
const TAG_DEV_APP_NAME = 'tag_dev';
/**
 * Should be used as appName for all dev tools consuming GQL, such as codegen, CLI migration tools, etc.
 */
export const TAG_DEV_TOOLS_NAME = 'ui_devtool';

/**
 * Format application name for API header.
 * Suffix is needed for DCM applications that need to report different app header for standalone/integrated mode.
 *
 * @param {string} appName - application name
 * @param {string} [suffix=''] - suffix to append to application name
 * @return {string}
 */
function formatApplicationName(appName: string, suffix = '') {
	return `tag_${appName}${suffix}`;
}

/**
 * Resolves required API headers.
 *
 * @param {IResolveAPIHeaders} { appName, appVersion, isDev, suffix }
 * @return {*}
 */
export function resolveAPIHeaders({ appName, appVersion, isDev = false, appNameSuffix }: IResolveAPIHeaders) {
	if (appName.startsWith('tag_')) {
		throw new Error('Application name should not start with "tag_"');
	}

	const headers: Record<string, string> = {};

	if (appVersion) {
		headers[CLIENT_APPLICATION_VERSION_HEADER] = appVersion;
	}

	if (typeof sessionStorage !== 'undefined') {
		const sessionId = getSessionId();
		if (sessionId) {
			headers[CLIENT_SESSION_ID_HEADER] = sessionId;
		}
	}

	return {
		...headers,
		[CLIENT_APPLICATION_HEADER]: isDev ? TAG_DEV_APP_NAME : formatApplicationName(appName, appNameSuffix),
		// Accept header is required for msw handlers to work properly
		Accept: 'application/json',
	};
}
